/**
 * DetencionesPanel — GEN-HU-005: lista de solo lectura de qué norma detuvo qué.
 * Owner-only: el ítem de menú lo proyecta el kernel y la puerta real es
 * GET /v1/detenciones (403 al no-owner). Reutiliza `TablaSimple` del visor de
 * mecanismos. Cabe en pantalla: Motivo parte en líneas y el Turno se trunca con su valor completo en el tooltip. Sin filtros ni paginación (el kernel devuelve las 100 últimas).
 */

import { useEffect, useState } from 'react'
import { listDetenciones } from '../api/client.js'
import { TablaSimple } from '../mecanismos/MechanismViewer.jsx'

const COLUMNAS = ['fecha', 'agente', 'turno', 'norma', 'motivo']
const ETIQUETAS = { fecha: 'Fecha', agente: 'Agente', turno: 'Turno', norma: 'Norma', motivo: 'Motivo' }

function celda(columna, fila) {
  if (columna === 'fecha') {
    const t = new Date(fila.fecha)
    return Number.isNaN(t.getTime()) ? '—' : t.toLocaleString('es-ES')
  }
  if (columna === 'turno') {
    // Id largo: se corta con puntos suspensivos (CSS) y el valor completo va en el tooltip.
    const completo = fila.chat_id && fila.message_id ? `${fila.chat_id} · ${fila.message_id}` : null
    return completo ? <span className="dk-turno" title={completo}>{completo}</span> : '—'
  }
  return fila[columna] || '—'
}

export default function DetencionesPanel() {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    let vivo = true
    listDetenciones()
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se han podido cargar las detenciones.' }))
    return () => { vivo = false }
  }, [])

  return (
    <section className="mec-visor">
      <h2>Detenciones</h2>
      <TablaSimple
        datos={datos}
        columnas={COLUMNAS}
        etiquetas={ETIQUETAS}
        filasDe={d => d.detenciones ?? []}
        vacio="Ninguna norma ha detenido una petición."
        celda={celda}
        clase="dk-detenciones"
      />
    </section>
  )
}
